import React, { useEffect, useState, useRef } from 'react';
import { ChevronDownIcon, CheckIcon } from 'lucide-react';
interface DropdownOption {
  value: string;
  label: string;
}
interface CustomDropdownProps {
  value: string;
  onChange: (value: string) => void;
  options: DropdownOption[];
  placeholder?: string;
  icon?: React.ReactNode;
}
export function CustomDropdown({
  value,
  onChange,
  options,
  placeholder = 'Select...',
  icon
}: CustomDropdownProps) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const selectedOption = options.find(opt => opt.value === value);
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
  return <div ref={dropdownRef} className="relative" data-id="element-74">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full px-4 py-3 bg-white border rounded-lg flex items-center justify-between transition-all" style={{
      borderColor: isOpen ? '#d4d4d4' : '#d1d5db',
      backgroundColor: isOpen ? '#f5f5f5' : 'white'
    }} data-id="element-75">
        <span className="text-sm font-medium" style={{
        color: selectedOption ? '#404040' : '#6b7280'
      }} data-id="element-76">
          {selectedOption ? selectedOption.label : placeholder}
        </span>
        <ChevronDownIcon className="w-4 h-4 transition-transform text-neutral-500" style={{
        transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)'
      }} data-id="element-77" />
      </button>
      {isOpen && <div className="absolute top-full left-0 right-0 mt-2 bg-white border border-neutral-300 rounded-lg shadow-lg z-50 overflow-hidden" data-id="element-78">
          <div className="max-h-64 overflow-auto" data-id="element-79">
            {options.map(option => <button key={option.value} onClick={() => {
          onChange(option.value);
          setIsOpen(false);
        }} className="w-full px-4 py-3 text-left flex items-center justify-between hover:bg-neutral-50 transition-all" style={{
          backgroundColor: value === option.value ? '#f5f5f5' : 'white'
        }} data-id="element-80">
                <span className="text-sm font-medium" style={{
            color: value === option.value ? '#404040' : '#374151'
          }} data-id="element-81">
                  {option.label}
                </span>
                {value === option.value && <CheckIcon className="w-4 h-4 text-neutral-600" data-id="element-82" />}
              </button>)}
          </div>
        </div>}
    </div>;
}